export default {
  requested: null,
  success: null,
  failed: null,
};
